<template>
  <v-stepper v-model="e1" class="password-stepper transform-password-stepper">
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="deposit-form" :class="$vuetify.theme.dark ? 'blue-lighten-2' : 'white-lighten-5'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Transfer to</legend>
                <v-select solo v-model="selectedTradingAccount" :items="formattedTradingAccounts" item-value="id"
                  item-text="formattedInfo" append-icon="mdi-chevron-down" label="Select One" class="custom-select"
                  hide-details @change="updateURL"></v-select>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Enter Amount (USD)</legend>
                <v-text-field v-model="amount" label="Enter Amount" single-line solo hide-details
                  class="custom-select" type="number"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn :loading="isLoading" :disabled="isLoading" tile elevation="0" class="ma-0 text-capitalize btn-account d-block w-100" color="teal-lighten-1"
              @click="sendOtp">
              Confirm
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card class="deposit-form" :class="$vuetify.theme.dark ? 'blue-lighten-2' : 'white-lighten-5'">
          <p class="mb-5">
            A verification code is sent to
            <span class="text--green">{{ profile?.email }}</span>
          </p>

          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Enter Verification Code</legend>
                <v-text-field v-model="otpCode" label="Enter here" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn :loading="isLoading" :disabled="isLoading" tile elevation="0"  type="submit" class="ma-0 text-capitalize btn-account w-100"
                color="teal-lighten-1" @click.prevent="verifyOtp">
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import toast from "@/services/Notification";
import {
  PROFILE__ACTIONS,
  TRADINGACCOUNTSTOTRANSFER__ACTIONS,
} from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      e1: 1,
      amount: null,
      isLoading: false,
      otpCode: null,
      selectedTradingAccount: null,
    };
  },

  computed: {
    ...mapState("tradingaccounts", ["tradingAccounts", "user_ib_balance"]),
    ...mapState("profile", ["profile"]),
    formattedTradingAccounts() {
      return this.tradingAccounts.map((account) => ({
        id: account.id,
        formattedInfo: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance/account.usd_rate} USD`,
      }));
    },
  },

  methods: {
    ...mapActions("tradingaccounts", [
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER,
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.INTERNALTRANSFERSENDOTP,
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMINTERNALTRANSFER,
    ]),
    ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),

    updateURL() {
      if (this.selectedTradingAccount !== null) {
        this.selectedTradingAccount = this.selectedTradingAccount;
        this.$router.push({ query: { id: this.selectedTradingAccount } });
      }
    },

    async sendOtp() {
      try {
        if (this.user_ib_balance < this.amount) {
          toast.error(`Insufficient Balance! Remaining Balance: ${this.user_ib_balance} USD`);
          return;
        }
        
        if (this.selectedTradingAccount === null) {
          toast.error("Please select an account!");
          return;
        }
        
        if (this.amount === null || this.amount <= 0) {
          toast.error("Please enter a valid amount!");
          return;
        }

        this.isLoading = true;
        const otpRes = await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.INTERNALTRANSFERSENDOTP]({
          client_trading_account_id: this.selectedTradingAccount,
          amount: this.amount,
        });

        if (otpRes.success) {
          this.e1 = 2;
        } else {
          toast.error(otpRes.message || "Failed to send verification code");
        }
      } catch (error) {
          toast.error(error.message || "An error occurred while sending OTP");
      } finally {
        this.isLoading = false;
      }
    },

    async verifyOtp() {
      try {
        if (!this.selectedTradingAccount && !this.amount) {
          toast.error("An error occurred during transfer");
          return;
        }
        if (!this.otpCode) {
          toast.error("Please enter the verification code");
          return;
        }
        this.isLoading=true;

        const response = await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMINTERNALTRANSFER]({
          verification_code: this.otpCode,
        });
        if (response.success) {
          this.selectedTradingAccount = null;
          this.amount = null;
          this.otpCode = null;
          this.e1 = 1;
        }
      } catch (error) {
        toast.error("An error occurred during transfer");
      } finally {
        this.isLoading=false;
      }
    },
  },

  async mounted() {
    await this[PROFILE__ACTIONS.PROFILE]();
    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER]();
    this.$router.push({ query: {} });
  },
};
</script>
